<template>
  <div class="form-group row">
    <label class="col-2 text-right">保障公式</label>
    <div class="col-10 d-inline-grid">
      <!-- 保障公式-1 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="formularType-1"
          :class="{ 'is-invalid': validate.isPosition_sErr }"
          v-model="form.position_s"
          value="1"
        />
        <label class="hide-label" for="formularType-1"></label>
        <span class="lh-40 ml-50">依</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr_s1 }"
          v-model="form.calc_basis_s1"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.fixedAmountBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr_s1 }"
          v-model="form.period_lower_s1"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr_s1 }"
          v-model="form.unit_lower_s1"
        >
          <option
            v-for="item in filterFormulaUnits_s1"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">~</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_upperErr_s1 }"
          v-model="form.period_upper_s1"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <span class="lh-40">{{
          pageControl.formulaUnits[form.unit_upper_s1 - 1]
            ? pageControl.formulaUnits[form.unit_upper_s1 - 1].text
            : ""
        }}</span>
        <span class="ml-15 lh-40">給付</span>
      </div>

      <!-- 保障公式-2 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="formularType-2"
          :class="{ 'is-invalid': validate.isPosition_sErr }"
          v-model="form.position_s"
          value="0"
        />
        <label class="hide-label" for="formularType-2"></label>
        <span class="lh-40 ml-50">依</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr_s2 }"
          v-model="form.calc_basis_s2"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.calculationBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">給付</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr_s2 }"
          v-model="form.period_lower_s2"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr_s2 }"
          v-model="form.unit_lower_s2"
        >
          <option
            v-for="item in filterFormulaUnits_s2"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">，最高給付上限</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          v-model="form.benefit_max"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <span class="ml-15 lh-40">萬元</span>
      </div>

      <!-- 保障公式-3 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="formularType-3"
          v-model="form.position_s"
          value="3"
        />
        <label class="hide-label" for="formularType-3"></label>
        <span class="lh-40 ml-50">計畫</span>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isSche_amtErr_s3 }"
          v-model="form.sche_nm_s3"
          @change="schemeChange_s3($event.target.selectedIndex)"
        >
          <option value="all" v-if="pageControl.schemeItems.length > 0">
            所有計畫
          </option>
          <option
            v-for="item in pageControl.schemeItems"
            :key="item.text"
            :value="item.text"
          >
            {{ item.text }}
          </option>
        </select>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr_s3 }"
          v-model="form.period_lower_s3"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr_s3 }"
          v-model="form.unit_lower_s3"
        >
          <option
            v-for="item in pageControl.formulaUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">給付</span>
      </div>

      <!-- 保障公式-4 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="formularType-4"
          v-model="form.position_s"
          value="4"
        />
        <label class="hide-label" for="formularType-4"></label>
        <span class="lh-40 ml-50">計畫</span>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isSche_amtErr_s4 }"
          v-model="form.sche_nm_s4"
          @change="schemeChange_s4($event.target.selectedIndex)"
        >
          <option value="all" v-if="pageControl.schemeItems.length > 0">
            所有計畫
          </option>
          <option
            v-for="item in pageControl.schemeItems"
            :key="item.text"
            :value="item.text"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">依</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr_s4 }"
          v-model="form.calc_basis_s4"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.fixedAmountBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr_s4 }"
          v-model="form.period_lower_s4"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr_s4 }"
          v-model="form.unit_lower_s4"
        >
          <option
            v-for="item in filterFormulaUnits_s4"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">~</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_upperErr_s4 }"
          v-model="form.period_upper_s4"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <span class="lh-40">{{
          pageControl.formulaUnits[form.unit_upper_s4 - 1]
            ? pageControl.formulaUnits[form.unit_upper_s4 - 1].text
            : ""
        }}</span>
        <span class="ml-15 lh-40">給付</span>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePageFormulaSingle",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    calculationBasisText_s1() {
      return this.form.calc_basis_s1
        ? this.pageControl.fixedAmountBasis.filter(
            (obj) => obj.value == this.form.calc_basis_s1
          )[0].text
        : "";
    },
    filterFormulaUnits_s1() {
      return this.pageControl.formulaUnits.filter((obj) =>
        //新增其他保障的固定金額選項
        ((this.form.calc_basis_s1 == "9" || this.form.calc_basis_s1 == "10") && obj.text == "元" )
        || (this.calculationBasisText_s1 == "固定金額" && obj.text != "元")
        ? false : true
      );
    },
    calculationBasisText_s2() {
      if(this.form.position_s =='0'){
        return this.form.calc_basis_s2
        ? this.pageControl.calculationBasis.filter(
          (obj) => obj.value == this.form.calc_basis_s2
          )[0].text
          : "";
        } else {
        return this.form.calc_basis_s2
      ? this.pageControl.fixedAmountBasis.filter(
        (obj) => obj.value == this.form.calc_basis_s2
        )[0].text
        : "";
      }
    },
    filterFormulaUnits_s2() {
      return this.pageControl.formulaUnits.filter((obj) =>
        this.calculationBasisText_s2 == "固定金額" ? obj.text == "元" : true
      );
    },
    calculationBasisText_s4() {
      return this.form.calc_basis_s4
        ? this.pageControl.fixedAmountBasis.filter(
            (obj) => obj.value == this.form.calc_basis_s4
          )[0].text
        : "";
    },
    filterFormulaUnits_s4() {
      return this.pageControl.formulaUnits.filter((obj) =>
        this.calculationBasisText_s4 == "固定金額" ? obj.text == "元" : true
      );
    },
  },
  watch: {
    "form.unit_lower_s1": {
      handler: function (value) {
        this.form.unit_upper_s1 = value;
      },
      immediate: true,
      deep: true,
    },
    "form.unit_lower_s4": {
      handler: function (value) {
        this.form.unit_upper_s4 = value;
      },
      immediate: true,
      deep: true,
    },
    calculationBasisText_s1: {
      handler: function (value) {
        if (value == "固定金額") {
          this.form.unit_lower_s1 = 1;
        }
      },
      deep: true,
    },
    calculationBasisText_s2: {
      handler: function (value) {
        if (value == "固定金額") {
          this.form.unit_lower_s2 = 1;
        }
      },
      deep: true,
    },
    calculationBasisText_s4: {
      handler: function (value) {
        if (value == "固定金額") {
          this.form.unit_lower_s4 = 1;
        }
      },
      deep: true,
    },
  },
  methods: {
    schemeChange_s3(i) {
      if (i == 0) {
        // this.form.sche_nm_s3 = "all";
        this.form.sche_amt_s3 = 0;
      } else {
        // this.form.sche_nm_s3 = this.pageControl.schemeItems[i - 1].text;
        this.form.sche_amt_s3 = this.pageControl.schemeItems[i - 1].value;
      }
    },
    schemeChange_s4(i) {
      if (i == 0) {
        // this.form.sche_nm_s4 = "all";
        this.form.sche_amt_s4 = 0;
      } else {
        // this.form.sche_nm_s4 = this.pageControl.schemeItems[i - 1].text;
        this.form.sche_amt_s4 = this.pageControl.schemeItems[i - 1].value;
      }
    },
  },
};
</script>
